module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sex-info",
    class: {
      'item-error': _vm.isError
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMale || _vm.selectedFemale),
      expression: "selectedMale || selectedFemale"
    }],
    staticClass: "user-sex-tit"
  }, [_vm._v("性别")]), _vm._v(" "), _c('div', {
    staticClass: "sex-item",
    class: {
      selected: _vm.selectedMale, hidden: _vm.selectedFemale
    },
    on: {
      "click": function($event) {
        return _vm.sexSelect(false)
      }
    }
  }, [_c('a', {
    staticClass: "user-sex male"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sex-item",
    class: {
      selected: _vm.selectedFemale, hidden: _vm.selectedMale
    },
    on: {
      "click": function($event) {
        return _vm.sexSelect(true)
      }
    }
  }, [_c('a', {
    staticClass: "user-sex female"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec227ca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/sex/index.vue
// module id = 351
// module chunks = 0